<template>
  <div class="accountsettings">
    <a-row class="securitybox">
      <a-col :span="24">
        <a-progress
          type="circle"
          :stroke-color="{
            '0%': '#108ee9',
            '100%': '#87d068',
          }"
          :percent="90"
        />
      </a-col>
      <a-col :span="24">
        <div class="titlebox">
          <h3>{{ this.accountsettings }}</h3>
          <p>{{ massage }}</p>
        </div>
      </a-col>
    </a-row>
    <a-row class="messagebox">
      <a-col :span="24">
        <h2>账号设置</h2>
      </a-col>
      <a-col :span="24">
        <ul>
          <li>
            <a-row>
              <a-col :span="8">
                <span><span>手&emsp;&emsp;</span><span>机</span></span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <span>{{
                  this.$store.state.netuser.iphone | vagueNumber
                }}</span>
                <router-link to="">{{ iphone }}</router-link></a-col
              >
            </a-row>
          </li>
          <li>
            <a-row>
              <a-col :span="8">
                <span><span>邮&emsp;&emsp;</span><span>箱</span></span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <span>{{
                  this.$store.state.netuser.mailbox | vagueNumber
                }}</span>
                <router-link to="">{{ mailbox }}</router-link></a-col
              >
            </a-row>
          </li>
          <li>
            <a-row>
              <a-col :span="8">
                <span>登录密码</span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <span>{{ passwordMessage }}</span>
                <router-link to="">{{ password }}</router-link></a-col
              >
            </a-row>
          </li>
          <li>
            <a-row>
              <a-col :span="8">
                <span>操作密码</span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <span>{{ confirmPasswordMessage }}</span>
                <router-link to="">{{ confirmPassword }}</router-link></a-col
              >
            </a-row>
          </li>
          <li>
            <a-row>
              <a-col :span="8">
                <span>三方账号</span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <span>QQ微信</span>
                <router-link to="">立即设置</router-link></a-col
              >
            </a-row>
          </li>
          <li>
            <a-row>
              <a-col :span="8">
                <span>登录记录</span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <router-link to="">查看记录</router-link></a-col
              >
            </a-row>
          </li>
          <li>
            <a-row>
              <a-col :span="8">
                <span>账号注销</span>
              </a-col>
              <a-col class="textright" :span="13" :offset="3">
                <router-link to="">立即注销</router-link></a-col
              >
            </a-row>
          </li>
        </ul>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "accountsettings",
  data() {
    return {
      accountsettings: "低风险",
      massage:
        "为了更好的保障您账号的安全，请您继续完善信息",
      password:'',
      mailbox:'',
      confirmPassword:'',
      iphone:'',


      passwordMessage:'',
      confirmPasswordMessage:'',
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.$get("/vr/netuser/accountMessage")
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
        this.password = response.data.password ? '修改密码' : '设置密码';
        this.mailbox = response.data.mailbox ? '修改邮箱' : '设置邮箱';
        this.confirmPassword = response.data.confirmPassword ? '修改操作密码' : '设置操作密码';
        this.iphone = response.data.iphone ? '修改手机' : '设置手机'; 
        this.passwordMessage = response.data.password ? '' : '存在风险，请设置密码'
        this.confirmPasswordMessage = response.data.confirmPassword ? '' : '存在风险，请设置操作密码'

        })
        .catch((error) => {
          this.$message.error(error.data, 5);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.accountsettings {
  width: 100%;
  height: 500px;
  //   background-color: rgb(224, 36, 124);
  .securitybox {
    text-align: center;
    padding-top: 1%;
    background: linear-gradient(rgb(173, 231, 202), rgb(255, 255, 255));
    .titlebox {
      margin-top: 0.5%;
      h3 {
        border-radius: 40% 40%;
        background-color: rgb(247, 152, 9);
        color: rgb(255, 255, 255);
        width: 8%;
        margin: 0 auto;
      }
      p {
        padding-top: 1%;
        font-size: 16px;
      }
    }
  }

  .messagebox {
    margin-top: 1%;
    background: rgb(255, 255, 255);
    padding: 1rem;
    height: 650px;
    h2 {
      padding: auto;
    }

    ul {
      font-size: 18px;
      padding: 1%;
      li {
        padding-left: 1%;
        padding-right: 2%;
        border-bottom: solid rgba(192, 192, 192, 0.514) 1px;
        line-height: 80px;
        .textright {
          text-align: right;
          span {
            padding-right: 8%;
          }
        }
      }

      li:last-child {
        border: none;
      }
      a {
        color: rgb(13, 200, 241);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/account/accountsettings.vue